import axios from 'axios';
import { readCookie } from './cookie';

const Axios = axios.create();

Axios.interceptors.request.use((config) => {
  config.baseURL = process.env.API_BASE_URL;
  const token = localStorage.getItem('token') || readCookie('token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default Axios;
